import moment from 'moment';

const transformFiltersForApi = conversationFilters => {
  const {
    dateRange,
    markedAsNotHelpful,
    includeProductionHubs,
    includeSuperadmin,
    includeClientAdmin,
    includeNonAdminUsers,
    raisedTicket,
    flaggedInternally,
    ...restFilters
  } = conversationFilters;

  // Transform dateRange to dateFrom and dateTo
  const apiFilters = {
    ...restFilters,
    markedAsNotHelpful: markedAsNotHelpful || false,
    includeProductionHubs: includeProductionHubs !== false, // Default to true
    includeSuperadmin: includeSuperadmin === true, // Default to false
    includeClientAdmin: includeClientAdmin !== false, // Default to true
    includeNonAdminUsers: includeNonAdminUsers !== false, // Default to true
    raisedTicket: raisedTicket || false,
    flaggedInternally: flaggedInternally || false,
  };

  // Add dateFrom and dateTo if dateRange exists
  if (dateRange && dateRange.start && dateRange.end) {
    apiFilters.dateFrom = moment(dateRange.start).utc().toISOString();
    apiFilters.dateTo = moment(dateRange.end).add(1, 'day').utc().toISOString();
  }

  return apiFilters;
};

export default transformFiltersForApi;
